import React, { Component } from "react";
import "./App.css";
import Layouts from "./components/Layouts";
import {
  BrowserRouter as Router,
  // Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import routers from "./router/index";
import Tab from "./components/Tab/index";
import intl from "react-intl-universal";
// 页面的标题
import DocumentTitle from "react-document-title";
import NotDefined from "./pages/NotDefined/index";
import { ActivityIndicator } from "antd-mobile-v2";
import history from "./config/history";
import cookie from "./utils/store/cookie";
// locale data
const locales = {
  "en-US": require("./locales/en-US.json"),
  "zh-CN": require("./locales/zh-CN.json"),
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      initDone: false,
    };
  }
  componentDidMount() {
    const time = 6000000000000000;
    if (cookie.get("language") != undefined) {
      this.loadLocales(cookie.get("language").locale);
    } else {
      cookie.set("language", { locale: "zh-CN" }, time);
      this.loadLocales("zh-CN");
    }
  }
  loadLocales(locale) {
    // init method will load CLDR locale data according to currentLocale
    // react-intl-universal is singleton, so you should init it only once in your app
    intl
      .init({
        currentLocale: locale, // TODO: determine locale here
        locales,
      })
      .then(() => {
        // After loading CLDR locale data, start to render
        this.setState({ initDone: true });
      });
  }

  render() {
    const token = this.props.token;
    return (
      <Layouts>
        <ActivityIndicator toast text="" animating={this.props.isLoading} />
        <Router history={history}>
          <Switch>
            {routers.map((route, key) => {
              return (
                <Route
                  exact={!!route.exact}
                  key={key}
                  path={route.path}
                  render={(renderHistory) => {
                    if (route.meta.backgroundColor) {
                      document.body.style.backgroundColor =
                        route.meta.backgroundColor;
                    } else {
                      document.body.style.backgroundColor = "#f5f5f5";
                    }
                    return (
                      <DocumentTitle title={route.meta.title}>
                        <div
                          className={
                            route.isTab ? "tabPageContent" : "noTabPageContent"
                          }
                        >
                          {!route.meta.auth ? (
                            <route.component
                              {...renderHistory}
                              routeMeta={route.meta}
                            />
                          ) : token ? (
                            <route.component
                              {...renderHistory}
                              routeMeta={route.meta}
                            />
                          ) : (
                            <Redirect
                              to={{
                                pathname: "/login",
                                state: { from: renderHistory.location },
                              }}
                            ></Redirect>
                          )}
                        </div>
                      </DocumentTitle>
                    );
                  }}
                ></Route>
              );
            })}
            {/* 匹配404页面 */}
            <Route path="*" component={NotDefined}></Route>
          </Switch>
          <Tab></Tab>
        </Router>
      </Layouts>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    token: state.app.token,
    isLoading: state.app.isLoading,
    data: state.app,
  };
};
export default connect(mapStateToProps)(App);
